import ParagraphTypeHpKwConverter from './theme/ParagraphTypeVueComponent/ParagraphTypeHpKwConverter.vue'
import ParagraphTypeBloodAlcoholCalculator from './theme/ParagraphTypeVueComponent/ParagraphTypeBloodAlcoholCalculator.vue'

const registerBrandVueComponents = (app) => {
  app.component('ParagraphTypeHpKwConverter', ParagraphTypeHpKwConverter)
  app.component('ParagraphTypeBloodAlcoholCalculator', ParagraphTypeBloodAlcoholCalculator)
}

export {
  registerBrandVueComponents
}
